import { store } from "../store";
import { validateStoredUser } from "../slices/userSlice";

export const initializeUser = () => {
  const storedUser = localStorage.getItem("pulselabs_user");
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      if (parsedUser.token) {
        store.dispatch(validateStoredUser(parsedUser.token));
      }
    } catch (error) {
      console.error("Failed to parse stored user:", error);
    }
  }
};
